import {
  type EditUserAccountDropdownOption,
  type EditUserAccountsDTO,
  type EditUserDropdownOption,
  type ParsedDropdownDataDTO,
} from "~/UserAccounts/EditUserAccountDTO";
import { type EditUserPageProps } from "~/UserAccounts/EditUserAccountModels";

export function transformData(dto: EditUserAccountsDTO): EditUserPageProps {
  const dropdownData = JSON.parse(dto.dropdownData) as ParsedDropdownDataDTO;

  return {
    uid: dto.uid,
    isSessionUser: dto.isSessionUser,
    dropdownData: {
      accounts: transformAccountDropdownField(dropdownData.accounts),
      customerCategoryOptions: transformDropdownField(dropdownData.customerCategoryOptions),
      functionalAreaOptions: transformDropdownField(dropdownData.functionalAreaOptions),
      jobTitleOptions: transformDropdownField(dropdownData.jobTitleOptions),
      knowledgeAreaOptions: transformDropdownField(dropdownData.knowledgeAreaOptions),
      languageOptions: transformDropdownField(dropdownData.languageOptions),
      roles: transformDropdownField(dropdownData.roles),
      salutationOptions: transformDropdownField(dropdownData.salutationOptions),
      statusOptions: transformDropdownField(dropdownData.statusOptions),
      titleOptions: transformDropdownField(dropdownData.titleOptions),
      countryOptions: transformDropdownField(dropdownData.countryOptions),
    },
    fields: {
      role: dto.fields.role,
      title: dto.fields.title,
      salutation: dto.fields.salutation,
      status: dto.fields.status,
      email: dto.fields.email,
      firstName: dto.fields.firstName,
      lastName: dto.fields.lastName,
      company: dto.fields.company,
      endCustomerCodes: dto.fields.endCustomerCodes,
      accountCodes: dto.fields.accountCodes,
      jobTitle: dto.fields.jobTitle,
      functionalArea: dto.fields.functionalArea,
      address: dto.fields.line1,
      addressAdditional: dto.fields.line2,
      zipCode: dto.fields.zipCode,
      city: dto.fields.city,
      country: dto.fields.country,
      phone: dto.fields.phone,
      knowledgeAreaCode: dto.fields.knowledgeAreaCode,
      languageIsoCode: dto.fields.languageIsoCode,
      customerCategoryCode: dto.fields.customerCategoryCode,
      vatNumber: dto.fields.vatNumber,
      lmsRequest: dto.fields.lmsRequest,
      termsTraining: false,
    },
    roleDescriptions: dropdownData.roles.map((role) => ({
      name: role.name,
      description: role.descriptionName,
    })),
    internalDomains: dropdownData.internalDomains,
    distributorAccounts: resolveDistributorAccounts(dropdownData.accounts),
    serviceProviderAccounts: resolveServiceProviderAccounts(dropdownData.accounts),
    defaultB2BUnit: dto.defaultB2BUnit,
  };
}

export function transformDropdownField(data: EditUserDropdownOption[]) {
  return data.map((option) => ({
    value: option.code,
    label: option.name,
  }));
}

export function transformAccountDropdownField(data: EditUserAccountDropdownOption[]) {
  return data.map((option) => ({
    value: option.code,
    label: option.name,
    endCustomerCodes: option.endCustomers,
  }));
}

export function resolveDistributorAccounts(data: EditUserAccountDropdownOption[]) {
  return data.filter((account) => account.isDistributor).map((account) => account.code);
}

export function resolveServiceProviderAccounts(data: EditUserAccountDropdownOption[]) {
  return data.filter((account) => account.isServiceProvider).map((account) => account.code);
}

// function transformEndCustomersDropdownField(
//   dto: EditUserAccountsFieldDTO,
//   values: EditUserAccountDropdownOption[]
// ): EditUserEndCustomerDropdownFieldModel {
//   return {
//     initial: dto.initialEndCustomers,
//     errors: dto.endCustomerErrors,
//     values: values
//       .map((account) => {
//         const i = account.name.lastIndexOf(",");
//         const accountDisplayName = account.name.substring(0, i).trim();
//         return account.endCustomers.map((option) => ({
//           code: option.endCustomerCode,
//           label: `${option.name}, ${option.code} (${accountDisplayName})`,
//           accountCode: option.endCustomerCode.split("-")[0],
//         }));
//       })
//       .flat(),
//   };
// }
